import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import {
    getFolderTable,
    Folder,
    ARCHIVE_FOLDERS_TREE_TYPE,
    SHARED_FOLDERS_TREE_TYPE,
    isPublicFolder,
} from 'owa-folders';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';

const MESSAGE_VIEW_ONLY_FOLDER_NAMES: DistinguishedFolderIdName[] = [
    'drafts',
    'junkemail',
    'recoverableitemsdeletions',
];

/**
 * Get the list view type for the folder
 * @param folderId the folder id
 */
export default function getListViewTypeForFolder(folderId: string): ReactListViewType {
    // Returns message view if the folder is default to message view, if
    // folder is or under archive mailbox root or shared folders root, or if
    // folder is a public folder
    if (folderId) {
        const folder: Folder = getFolderTable().get(folderId);
        // Check if folder is undefined : happens during the initial boot, when the folder table has not been populated
        if (
            (folder &&
                (MESSAGE_VIEW_ONLY_FOLDER_NAMES.indexOf(folderIdToName(folderId)) != -1 ||
                    folder.treeType === ARCHIVE_FOLDERS_TREE_TYPE ||
                    folder.treeType === SHARED_FOLDERS_TREE_TYPE)) ||
            isPublicFolder(folderId)
        ) {
            return ReactListViewType.Message;
        }
    }

    // Return the GlobalListViewTypeReact in user options
    // For backward compatibility, return conversation view for users on utah version less than 15.20.0059.000
    // Because users don't have GlobalListViewTypeReact in the UserOptions
    const globalListViewTypeReact = getUserConfiguration().UserOptions.GlobalListViewTypeReact;
    return globalListViewTypeReact || ReactListViewType.Conversation;
}
